import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { HttpHeaders } from '@angular/common/http';
import { FiltersModel } from 'src/app/shared/models/FiltersModel.model';
import { BookingListModel } from 'src/app/shared/models/BookingListModel.model';
import { BookingModel } from 'src/app/shared/models/BookingModel.model';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  private userToken:string;

  constructor(private http: HttpClient, private authenticationService: AuthenticationService) { 
    const $this = this;
    $this.userToken = $this.authenticationService.currentUserValue.Token;
  }

  public GetBookingByIpAddress(): Observable<any> {

    const $this = this;

    return $this.http.get<any>(environment.apiUrl + 'api/v1/Booking/GetBookingByIpAddress/' + location.host).pipe();

  }

  public GetAllColumnNames(): Observable<string[]>{
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization',  'Bearer ' + $this.userToken)
    }

    return $this.http.get<string[]>(environment.apiUrl + 'api/v1/Booking/GetAllColumnNames', header).pipe();
  }

  public DeleteListOfBookings(listOfDocuments: any[]):Observable<any> {
    const $this = this;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
      .set('Authorization',  'Bearer ' + $this.userToken),
      body: listOfDocuments,
    };
    return $this.http.delete<any>(environment.apiUrl + 'api/v1/Booking', options).pipe();
  }

  public GetAllBookings(filterParameters: FiltersModel): Observable<BookingListModel> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization',  'Bearer ' + $this.userToken)
    }

    return $this.http.post<BookingListModel>(environment.apiUrl + 'api/v1/Booking/GetAllBookings', filterParameters, header).pipe();
  }

  public GetBookingById(id:number): Observable<BookingModel>{
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization',  'Bearer ' + $this.userToken)
    }

    return $this.http.get<BookingModel>(environment.apiUrl + 'api/v1/Booking/' + id, header).pipe();
  }
}
